/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICategoryTileViewProps } from './category-tile';

export default (props: ICategoryTileViewProps) => {
    const { config } = props;
    return (
        <a
            href={config.categoryUrl?.destinationUrl || '#'}
            className='category-tile'
            style={{
                backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%), url(${config.backgroundImage.src ||
                    config.backgroundImage})`
            }}
            aria-label={config.title}
        >
            <span className='category-tile__title'>{config.title}</span>
        </a>
    );
};
